import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';

export const CarePlan1SuggestionSchema = yup.object({
  movementAids: SuggestionSchema.nullable(),
  lowResilience: SuggestionSchema.nullable(),
  goals: SuggestionSchema.nullable(), // TO DO: this should be conditional Suggestions depending on the properties fallRisk,decubitusRisk and contractureRisk
  exercises: SuggestionSchema.nullable(),
  accompainment: SuggestionSchema.nullable(),
  provideProtectors: SuggestionSchema.nullable(),
  fixationMethod: SuggestionSchema.nullable(),
  beddingMethod: SuggestionSchema.nullable(),
  aids: SuggestionSchema.nullable(),
  pressureReliefMethod: SuggestionSchema.nullable(),
  skinInspection: SuggestionSchema.nullable(),
  pneumoniaProphylaxis: SuggestionSchema.nullable(),
  thrombosisProphylaxis: SuggestionSchema.nullable(),
  other: SuggestionSchema.nullable(),
});

export type ICarePlan1Suggestion = yup.InferType<typeof CarePlan1SuggestionSchema>;
